import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Response } from './Models/Response';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharkifyAiSerivceService {
  BaseUrl = "https://Technology.sharkify.ai/";
  // BaseUrl = "http://localhost:63654/";
  // apiUrl ="https://Service.sharkify.ai/";
  // configurl = "https://Service.sharkify.ai/";
  configurl = environment.apiUrl;
  apiUrl = environment.apiUrl;
  

  private businessInfo: any;

  setBusinessInfo(data: any) {
    this.businessInfo = data;
  }
  getBusinessInfo() {
    return this.businessInfo;
  }
  payudata(data: any) {
    return this.http.post<any>(`${this.configurl + 'payment/payupayment'}`, data)
  }
  
  getTransactionsByUserId(UserId : number): Observable<any> {
    return this.http.post(`${this.configurl + 'payment/transactions'}`, { UserId } );
  }
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };


  constructor(private http: HttpClient, public route: ActivatedRoute) { }

  // Method to handle client login
  public ClientLogin(Email: string, Password: string) {
    const loginData = {
        Email,Password, UserType: 'Client'
    };
    return this.http.post<any>(`${this.apiUrl}auth/login`, loginData);
  }
  public ClientSocialMediaAccountLogin(Email: string, MobileNumber: string,FirstName : string,LastName :string , AccountType : string , AccountId : string , Photo : string) {
    let params = new HttpParams();
    params = params.append("Email", Email + "");
    params = params.append("MobileNumber", MobileNumber); 
    params = params.append("FirstName", FirstName);
    params = params.append("LastName", LastName);
    params = params.append("AccountType", AccountType);
    params = params.append("AccountId", AccountId);
    params = params.append("Photo", Photo);
    return this.http.post<Response>(`${this.BaseUrl + "ClientSocialMediaAccountLogin"}`, params);
  }

  // Method to handle client registration (if needed)
  public ClientRegistration(
    FirstName: string, 
    LastName: string, 
    MobileNumber: string, 
    Email: string, 
    Password: string
  ) {
    const user = {
      FirstName,
      LastName,
      MobileNumber,
      Email,
      Password,
      UserType: 'Client'
    };
    return this.http.post<Response>(`${this.apiUrl}auth/client-registration`,user);
  }

  public ScheduleNewEvent(UserId: string, BusinessInfoId: string, AccountId: string, EventMediaLinks: string, EventCaption: string, ScheduledDate: string, Hours: string, Minutes: string) {
      const event ={
        UserId,
        BusinessInfoId,
        AccountId,
        EventMediaLinks,
        EventCaption,
        ScheduledDate,
        Hours,
        Minutes
      };
      return this.http.post<Response>(`${this.apiUrl}event/scheduleNewEvent`, event);
  }

  public CheckPromoCodeAvailibility(PromoCode: string) {
    const checkpromocode={
      PromoCode
    }
    return this.http.post<Response>(`${this.apiUrl}promoCode/checkAvailability`, checkpromocode);
  }
  public AddPromoCode(PromoCode: string, PromoType: string, Amount:string,Percentage: string,Description: string, ValidatyDate: string) {
    const addpromocode={
      PromoCode,
      PromoType,
      Amount,
      Percentage,
      Description,
      ValidatyDate
    }
    return this.http.post<Response>(`${this.apiUrl}promoCode/add`, addpromocode);
  }


  public ActivePromoCodes() {
    const activepromocode={}
    return this.http.post<Response>(`${this.apiUrl}promoCode/active`, activepromocode);
  }
  
  public VouchersList(CreatedBy : string){
    const voucherslist={
      CreatedBy
    }
    return this.http.post<Response>(`${this.BaseUrl}voucher/vouchersList` , voucherslist);
  }

  public CheckVoucherAvailibility(VoucherCode : string){
    const checkvoucher={
      VoucherCode
    }
    return this.http.post<Response>(`${this.apiUrl}voucher/checkVoucherAvailability`, checkvoucher);
  } 

  public UpdatedVoucher(VoucherId : number,VoucherValue : string){
    const updatevoucher={
      VoucherId,
      VoucherValue
    }
    return this.http.post<Response>(`${this.apiUrl}voucher/updateVoucher`, updatevoucher);
  } 

  public CreateNewVoucher(VoucherCode : string,VoucherValue : string,CreatedBy : string){
    const createnewvoucher={
      VoucherCode, 
      VoucherValue,
      CreatedBy
    }
    return this.http.post<Response>(`${this.apiUrl}voucher/createNewVoucher` , createnewvoucher);
  }

  public DeleteVoucher(VoucherId : string){
    const deletevoucher={
      VoucherId
    }
    return this.http.post<Response>(`${this.apiUrl}voucher/deleteVoucher` , deletevoucher);
  }


  public UpdateBusinessInfo(UserId: string, BusinessInfoId: string, BusinessInfo_BusinessName: string, BusinessInfo_BusinessCategory: string, BusinessInfo_BusinessCode: string, BusinessInfo_BusinessType: string, BusinessInfo_WebsiteURL: string, CurrentOnlinePresence_DoYouCurrentlySellOnline: string, CurrentOnlinePresence_InstagramFollowers: string, CurrentOnlinePresence_InstagramUsername: string, CurrentOnlinePresence_LinkedInUsername: string,
    ContentRequirements_IntrestedContent: string, ContentRequirements_SpecificThemes: string, ContentRequirements_Description: string, ContentRequirements_SampleImages: string,
    TargetAudience_FromAge: string, TargetAudience_ToAge: string, TargetAudience_Gender: string, TargetAudience_Interests: string, TargetAudience_SpecificLocations: string,
    ContentGoals_PrimaryGoals: string, ContentGoals_KeyMessages: string,
    RegularPostingSchedule_Customize: string, RegularPostingSchedule_Mon: string, RegularPostingSchedule_Tue: string, RegularPostingSchedule_Wed: string, RegularPostingSchedule_Thu: string, RegularPostingSchedule_Fri: string, RegularPostingSchedule_Sat: string, RegularPostingSchedule_Sun: string,
    BusinessSpecificUploads_Images: string, BusinessSpecificUploads_Services: string,
    CompetitorInformation_Details: string, AdditionalDetails_Details: string,
  ) {
    const requestBody = {
      UserId,
      BusinessInfoId,
      BusinessInfo_BusinessName,
      BusinessInfo_BusinessCategory,
      BusinessInfo_BusinessCode,
      BusinessInfo_BusinessType,
      BusinessInfo_WebsiteURL,
      CurrentOnlinePresence_DoYouCurrentlySellOnline,
      CurrentOnlinePresence_InstagramFollowers,
      CurrentOnlinePresence_InstagramUsername,
      CurrentOnlinePresence_LinkedInUsername,
      ContentRequirements_IntrestedContent,
      ContentRequirements_SpecificThemes,
      ContentRequirements_Description,
      ContentRequirements_SampleImages,
      TargetAudience_FromAge,
      TargetAudience_ToAge,
      TargetAudience_Gender,
      TargetAudience_Interests,
      TargetAudience_SpecificLocations,
      ContentGoals_PrimaryGoals,
      ContentGoals_KeyMessages,
      RegularPostingSchedule_Customize,
      RegularPostingSchedule_Mon,
      RegularPostingSchedule_Tue,
      RegularPostingSchedule_Wed,
      RegularPostingSchedule_Thu,
      RegularPostingSchedule_Fri,
      RegularPostingSchedule_Sat,
      RegularPostingSchedule_Sun,
      BusinessSpecificUploads_Images,
      BusinessSpecificUploads_Services,
      CompetitorInformation_Details,
      AdditionalDetails_Details
    };
    return this.http.post<Response>(`${this.apiUrl + BusinessInfoId + '/' + UserId}`, requestBody);
  }

  public GetBusinessInfoDetails(UserId: string) {
    return this.http.get<any>(`${this.apiUrl + 'business/' + UserId}`);
  }

  public DeleteBusinessInfo(UserId: string, BusinessInfoId: string) {
    const requestPayload ={
      Status: 'Deleted'
    }
    return this.http.post<Response>(`${this.apiUrl + "business/" + BusinessInfoId + '/' + UserId}`, requestPayload);
  }

  public DeleteSocialMediaAccount(AccountId: string, UserId: string) {
    const requestPayload = {
      UserId,
      AccountId
    }
    return this.http.post<Response>(`${this.apiUrl + "social-media-account/delete"}`, requestPayload);
  }

  
  // public UpdateClientProfilePhoto(UserId: string, Photo: string) {
  //   let params = new HttpParams();
  //   params = params.append("UserId", UserId);
  //   params = params.append("Photo", Photo);
  //   return this.http.post<Response>(`${this.BaseUrl + "UpdateClientProfilePhoto"}`, params);
  // }
  
  public UpdateClientProfileDetails(UserId: string, FirstName: string, LastName: string, MobileNumber: string, AddressLineOne: string, AddressLineTwo: string, City: string, State: string, Pincode: string) {
    const requestPayload  = {
      UserId,
      FirstName,
      LastName,
      MobileNumber,
      AddressLineOne,
      AddressLineTwo,
      City,
      State,
      Pincode
    }
    return this.http.post<Response>(`${this.apiUrl + "UpdateClientProfileDetails"}`, requestPayload);
  }

  public UpdateClientProfilePassword(UserId: string, UserType: string, Password: string) {
    const requestInfo = {
      UserType,
      Password
    }
    return this.http.post<Response>(`${this.apiUrl + "user/" +UserId}`, requestInfo);
  }

  public AccountManagerLogin(Email: string, Password: string) {
    const loginData = {
      Email,Password, UserType: 'Manager'
  };
  return this.http.post<any>(`${this.apiUrl}auth/login`, loginData);
  }

  public AccountManagerRegistration(FirstName: string, LastName: string, MobileNumber: string, Email: string, Password: string) {
      const user = {
        FirstName,
        LastName,
        MobileNumber,
        Email,
        Password,
        UserType: 'Manager',
      };
    return this.http.post<any>(`${this.apiUrl}/auth/manager-registration`, user);
  }
  public NewClientsWithBusinessDetails(UserId: string) {
    const requestPayload = {
      UserId
    }
    return this.http.post<Response>(`${this.apiUrl + "account-access/new-clients"}`, requestPayload);
  }
//   public UpdateAccountManagerProfilePhoto(UserId: string, Photo: string) {
//     let params = new HttpParams();
//     params = params.append("UserId", UserId);
//     params = params.append("Photo", Photo);
//     return this.http.post<Response>(`${this.BaseUrl + "UpdateAccountManagerProfilePhoto"}`, params);

// }
public ClientBusinessesHandledByManager(ManagerUserId:string) {
  let params = new HttpParams();
  params = params.append("ManagerUserId",ManagerUserId);
  return this.http.post<Response>(`${this.BaseUrl + "ClientBusinessesHandledByManager"}`, params);
}

public SendBusinessAccountAccessRequest(ManagerUserId:string,ClientUserId:string,BusinessInfoId:string) {
  let params = new HttpParams();
  params = params.append("ManagerUserId",ManagerUserId);
  params = params.append("ClientUserId",ClientUserId);
  params = params.append("BusinessInfoId",BusinessInfoId);
  return this.http.post<Response>(`${this.BaseUrl + "SendBusinessAccountAccessRequest"}`, params);
}

  public ClientAccountAccessRequests (ClientUserId:string){
    let params = new HttpParams();
    params = params.append("ClientUserId",ClientUserId);    
    return this.http.post<Response>(`${this.BaseUrl + "ClientAccountAccessRequests"}`, params);
  }
  public ApproveOrDeclineAccountAccessRequest (RequestId:string,Status:string,PermissionType:string){
    let params = new HttpParams();
    params = params.append("RequestId",RequestId); 
    params = params.append("Status",Status); 
    params = params.append("PermissionType",PermissionType);    
    return this.http.post<Response>(`${this.BaseUrl + "ApproveOrDeclineAccountAccessRequest"}`, params);
  }
  public ListOfSocialMediaAccounts (UserId:string,BusinessInfoId:string){
    const requestBody = {
      UserId: UserId,
      BusinessInfoId: BusinessInfoId
    };
    return this.http.post<any>(`${this.apiUrl + "social-media-account/list"}`, requestBody);
  }
  // public ScheduledEventsForSocialMediaAccount (UserId:string,BusinessInfoId:string,AccountID:number){
  //   const requestData = {
  //     UserId,
  //     BusinessInfoId,
  //     AccountID
  //   }   
  //   return this.http.post<Response>(`${this.apiUrl + "event/scheduledEventsForSocialMediaAccount"}`, requestData);
  // }
  // public ScheduleNewEvent(UserId: string, BusinessInfoId: string, AccountId: string, EventMediaLinks: string, EventCaption: string, ScheduledDate: string, Hours: string, Minutes: string) {
  //   const requestPayload = {
  //     UserId,
  //     BusinessInfoId,
  //     AccountId,
  //     EventMediaLinks,
  //     EventCaption,
  //     ScheduledDate,
  //     Hours,
  //     Minutes
  //   }
  //   return this.http.post<Response>(`${this.apiUrl + "event/scheduleNewEvent"}`, requestPayload);
  // }
  public ScheduledEventsForSocialMediaAccount (UserId:string,BusinessInfoId:string,AccountID:number){
    const requestData = {
      UserId,
      BusinessInfoId,
      AccountID
    }   
    return this.http.post<Response>(`${this.apiUrl + "event/scheduledEventsForSocialMediaAccount"}`, requestData);
  }

  public updateUser(id: any, details: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}user/${id}`, details); 
  }
  public managerCreatPost(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}post`, data); 
  }
  public UpdateAccountManagerProfilePhoto(data: any,userId: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}user/managerProfile/${userId}`, data); 
  }
  public ContactUs(details: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}user/contact/`, details); 
  }
  public UpdateClientProfilePhoto(data: any, userId: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}user/clientProfile/${userId}`, data);
  }
  public AddBusinessInfo(UserId: string,businessInfo: any,
  ) {
    return this.http.post<any>(`${this.apiUrl}business/questionary/${UserId}`, businessInfo);
  }

  public createSocialMediaAccount(code: string, userId: string, businessInfoId: string, connectType: string){
    return this.http.get<any>(`${this.apiUrl}user/auth/callback?code=${code}&userId=${userId}&businessInfoId=${businessInfoId}&connectType=${connectType}`);
  }

  public createVerification(email:string,userId:string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}verification`, {
      VerifyingUsing: email,
      UserId: userId,
      VerificationType: 'email',
    });
  }
  public verifyOtp(email: string, otp: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}verification/verify`, {
      VerifyingUsing: email,
      VerificationCode: otp,
    });
  }
  public approveEvent(eventId: number){
    return this.http.post<any>(`${this.apiUrl}post/approve/${eventId}`, {});
  }
}
